import Vue from 'vue'
import VueGtag from 'vue-gtag'

const setupGoogleAnalytics = (app) => {
    if (app.$isTargetingAllowed && app.$isTargetingAllowed()){
        Vue.use(VueGtag, {
            config: { id: process.env.NUXT_ENV_APP_ENV_NAME == 'production' ? 'G-RF9HN9BW1D' : 'dummy' },
            appName: 'Stan Store',
            disableAutoPageTrack: false,
            params: {
                send_page_view: false
            },
            pageTrackerScreenviewEnabled: true,
        }, app.router);
        return true
    }
    return false
}

export default ({ app}) => {
    // Try to setup google analytics, if not wait for cookie banner to be processed
    let initalized = false
    document.addEventListener('cookie-banner-processed', () => {
        if (!initalized) {
            setupGoogleAnalytics(app)
        }
    })
    initalized = setupGoogleAnalytics(app)

}